// extracted by mini-css-extract-plugin
export default {"container":"TituloSemImagem_container__m3gat","titulo":"TituloSemImagem_titulo__+mCLb","descricao":"TituloSemImagem_descricao__YAmVx"};